import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/lib/auth';

interface PracticeHubAccess {
  enabled: boolean;
  loading: boolean;
  enabledAt: string | null;
}

export function usePracticeHubAccess(): PracticeHubAccess {
  const { user } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [enabledAt, setEnabledAt] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAccess = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('client_settings')
          .select('practice_hub_enabled, practice_hub_enabled_at')
          .eq('client_id', user.id)
          .maybeSingle();

        if (error) {
          console.error('Error fetching practice hub access:', error);
          setEnabled(false);
        } else {
          setEnabled(data?.practice_hub_enabled ?? false);
          setEnabledAt(data?.practice_hub_enabled_at ?? null);
        }
      } catch (err) {
        console.error('Error fetching practice hub access:', err);
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    fetchAccess();
  }, [user]);

  return { enabled, loading, enabledAt };
}
